import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import {
  Container,
} from "reactstrap";
import { Outlet } from "react-router-dom";

import Breadcrumb from "../../../components/Breadcrumb";

const QuizWrapper: FunctionComponent = () => {
  const intl = useIntl();

  return (
    <>
      <Breadcrumb
        parent={intl.formatMessage({id: "page.index.title", defaultMessage: "Namedicinu"})}
        title={intl.formatMessage({id: "module.quiz.title", defaultMessage: "Quiz"})}
      />
      <Container fluid={true} className="quiz">
        <Outlet />
      </Container>
    </>
  );
}

export default QuizWrapper;